import React, { Component } from 'react'
import { connect } from 'react-redux'
import { savingInProgress, savingModelsToDB, reviewCompleted } from '../../actions/data'
import './ModelHoldings.css'
import i18n from '../../i18n'

function formatWeight(weight) {
  return parseFloat(weight).toFixed(2) + '%'
}

class ModelHoldings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAll: []
    }
    this.saveCustomModelsToDB = this.saveCustomModelsToDB.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data) {
      if (nextProps.data !== prevState.data) {
        return { data: nextProps.data }
      }
    } else {
      console.error('nextProps.data is undefined')
    }

    return null
  }

  toggleShowAll = index => {
    this.setState(prevState => {
      const newShowAll = [...prevState.showAll]
      newShowAll[index] = !newShowAll[index]
      return { showAll: newShowAll }
    })
  }

  saveCustomModelsToDB() {

    const {
      selectedModels,
      selectedNames,
      savedSleved,
      savingModelsToDB,
      savingInProgress,
      reviewCompleted,
      updatedNames
    } = this.props
    console.log('updated Names', updatedNames)

    savingModelsToDB(selectedModels, selectedNames, savedSleved)
    reviewCompleted()
    window.scrollTo(141, 865)
  }

  render() {
    const {
      data,
      savedSleved,
      selectedApproach,
      selectedNames,
      selectedModels
    } = this.props

    console.log('selectedModels***', selectedModels)
    console.log('selectedNames', selectedNames)
    console.log('savedSleved', savedSleved)

    const minLength = Math.min(...selectedNames.map(name => name.length));
    if (!data || !data.models) {
      return <div>Loading...</div>
    }

    let dataWithHoldings = []
    if (
      data &&
      data.models &&
      Array.isArray(selectedModels) &&
      Array.isArray(selectedNames)
    ) {
      dataWithHoldings = selectedModels.map((model, index) => {
        const item = data.models.find(item => item.ticker === model);
        if (item) {
          return {
            ...item,
            name: selectedNames[index],
            originalIndex: index
          }
        }
        return null;
      }).filter(item => item !== null)
        .sort((a, b) => a.originalIndex - b.originalIndex);
    } else {
      console.error(
        'data.models is undefined or not an array, selectedModels or selectedNames is also problematic'
      )
    }
    if (
      dataWithHoldings &&
      Array.isArray(dataWithHoldings) &&
      savedSleved &&
      Array.isArray(savedSleved.swaps)
    ) {
      dataWithHoldings = dataWithHoldings.map(item => {
        if (item.holdings) {
          const newHoldings = item.holdings.map(holding => {
            if (holding.tickers) {
              const newTickers = holding.tickers.map(ticker => {
                const swap = savedSleved.swaps.find(
                  swap => swap.originalTicker === ticker
                )
                return swap ? swap.newTicker : ticker
              })
              return { ...holding, tickers: newTickers }
            }
            return holding
          })
          return { ...item, holdings: newHoldings }
        }
        return item
      })
    } else {
      console.error(
        'dataWithHoldings is MIA'
      )
    }

    //sorting the dataWithHoldings array based on the total number of tickers in each model's holdings.
    const sortedDataWithHoldings = [...dataWithHoldings].sort(
      (a, b) => {
        const totalTickersA = a.holdings.reduce((sum, holding) => sum + holding.tickers.length, 0);
        const totalTickersB = b.holdings.reduce((sum, holding) => sum + holding.tickers.length, 0);
        return totalTickersB - totalTickersA;
      }
    );
    console.log('sortedDataWithHoldings', sortedDataWithHoldings)
    /*For each model, it iterates over its holdings.
For each holding, it creates a new array combined where each element is an object containing the ticker, its corresponding weight, and its corresponding asset class. The index i is used to match the ticker with its weight and asset class.
Then, it sorts the combined array in descending order based on the weight of each ticker.
Finally, it updates the tickers, weights, and assetClasses arrays of the holding to be in the same order as the sorted combined array. This means that after this code runs, the tickers in each holding will be ordered by their weights in descending order, and the weights and asset classes will be in the same order as their corresponding tickers.*/
    // sortedDataWithHoldings.forEach(model => {
    //   model.holdings.forEach(holding => {
    //     let combined = holding.tickers.map((ticker, i) => ({
    //       ticker: ticker,
    //       weight: holding.weights[i],
    //       assetClasses: holding.assetClasses[i]
    //     }))
    //     combined.sort((a, b) => b.weight - a.weight)
    //     holding.tickers = combined.map(item => item.ticker)
    //     holding.weights = combined.map(item => item.weight)
    //     holding.assetClasses = combined.map(item => item.assetClasses)
    //   })
    // })


    const assetClassSortOrder = ['Equity', 'Fixed Income', 'Alternatives', 'Cash'];

    let allTickersWithDetails = sortedDataWithHoldings.flatMap(item =>
      item.holdings.flatMap(holding =>
        holding.tickers.map((ticker, i) => ({
          ticker: ticker,
          weight: holding.weights[i],
          assetClass: holding.assetClasses[i],
          holdingName: holding.names ? holding.names[i] : undefined
        }))
      )
    );

    console.log('allTickersWithDetails', allTickersWithDetails)
    allTickersWithDetails.sort((a, b) => {
      const assetClassIndexA = assetClassSortOrder.indexOf(a.assetClass);
      const assetClassIndexB = assetClassSortOrder.indexOf(b.assetClass);

      if (assetClassIndexA === assetClassIndexB) {
        return b.weight - a.weight; // sort by weight in descending order if asset classes are the same
      } else {
        return assetClassIndexA - assetClassIndexB; // sort by asset class order if asset classes are different
      }
    });

    const allTickers = [...new Set(allTickersWithDetails.map(item => item.ticker))];
    console.log('allTickers', allTickers)
    const assetClasses = [...new Set(sortedDataWithHoldings.flatMap(item => item.holdings.flatMap(holding => holding.assetClasses)))];
    //   const assetClassSortOrder = ['Equity', 'Fixed Income', 'Alternatives', 'Cash']
    //   const allTickers = [...new Set(sortedDataWithHoldings.flatMap(item => item.holdings.flatMap(holding => holding.tickers)))];
    return (
      <div classname='review-container'>
        <div className='review-title'>{i18n.t('PORTFOLIO HOLDINGS')}</div>
        <div className='review-subtitle'>{i18n.t('review_models_text')}</div>
        <div className='holdings-container'>
          <table className='holdings-table '>
            <thead>
              <tr>
                <th className='table-header equal-width'>Ticker</th>
                {sortedDataWithHoldings.map((item, modelIndex) => (
                  <th key={modelIndex} className='table-header equal-width' title={item.name}>
                    {item.name.length > 50 ? item.name.substring(0, 50) + '...' : item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {assetClasses.map((assetClass, assetClassIndex) => {
                const tickersInAssetClass = allTickers.filter(ticker => {
                  return sortedDataWithHoldings.some(item =>
                    item.holdings.some(holding =>
                      holding.tickers.includes(ticker) && holding.assetClasses[holding.tickers.indexOf(ticker)] === assetClass
                    )
                  );
                });

                return (
                  <>
                    <tr key={assetClassIndex} className='asset-class-bold-row'>
                      <td className='table-data' data-label="Asset Class" colSpan={sortedDataWithHoldings.length + 1}>{assetClass}</td>
                    </tr>
                    {tickersInAssetClass.map((ticker, tickerIndex) => {
                      const tickerDetails = allTickersWithDetails.find(item => item.ticker === ticker);
                      const holdingName = tickerDetails ? tickerDetails.holdingName : '';

                      return (
                        <tr key={`${assetClassIndex}-${tickerIndex}`}>
                          <td className='table-data' data-label="Ticker" title={holdingName}>{ticker}</td>
                          {sortedDataWithHoldings.map((item, modelIndex) => {
                            const holding = item.holdings.find(holding => holding.tickers.includes(ticker));
                            const weight = holding ? formatWeight(holding.weights[holding.tickers.indexOf(ticker)]) : '-';
                            return <td key={modelIndex} className='weights' data-label={item.name}>{weight}</td>
                          })}
                        </tr>
                      );
                    })}
                  </>
                );
              })}
            </tbody>
          </table>
        </div>


        {/* 
        <div className='holdings-container'>
          {sortedDataWithHoldings.map((item, modelIndex) => (
            <div key={modelIndex} className='item'>
              <table className='holdings-table' >
                <thead>
                  <tr>
                    <th className='table-header' colSpan='2'>
                      {item.name.length > minLength ? item.name.substring(0, minLength) + '...' : item.name}
                    </th>
                  </tr>
                  <tr>
                    <th className='table-header'>Ticker</th>
                    <th className='table-header right-align'>Weights</th>
                  </tr>
                </thead>
                <tbody>
                  {item.holdings.map((holding, holdingIndex) => {
                    const groupedByAssetClass = holding.tickers.reduce((acc, ticker, i) => {
                      const assetClass = holding.assetClasses[i]
                      if (!acc[assetClass]) {
                        acc[assetClass] = {
                          tickers: [],
                          weights: [],
                          names: [],
                          selectedName: holding.names[i]
                        }
                      }
                      acc[assetClass].tickers.push(ticker)
                      acc[assetClass].weights.push(holding.weights[i])
                      acc[assetClass].names.push(holding.names[i])
                      return acc
                    }, {})

                    const sortedAssetClasses = Object.entries(groupedByAssetClass).sort(([a], [b]) => {
                      const indexA = assetClassSortOrder.indexOf(a);
                      const indexB = assetClassSortOrder.indexOf(b);
                      if (indexA === -1 || indexB === -1) {
                        return a.localeCompare(b);
                      }
                      return indexA - indexB;
                    });

                    return sortedAssetClasses.map(
                      ([assetClass, data], i) => (
                        <React.Fragment key={i}>
                          <tr className='asset-class-row'>
                            <td colSpan='2'>
                              {assetClass}
                            </td>
                          </tr>
                          {data.tickers.map((ticker, i) => (
                            <tr key={i}>
                              <td className='table-data' title={data.names[i]}>
                                {ticker}
                              </td>
                              <td className='table-data right-align'>
                                {formatWeight(data.weights[i])}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )
                    )
                  })}
                </tbody>
              </table>
            </div>
          ))}
        </div> */}
        <div className='holdings-button-container'>
          <button className='holdings-save-button' onClick={this.saveCustomModelsToDB}>
            Save Models
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  clientEmail: state.params.clientEmail,
  savedSleved: state.data.sleeveSaved,
  data: state.data,
  selectedRiskProfileNumber: state.data.selectedRiskProfileNumber,
  selectedApproach: state.data.selectedApproach,
  selectedModels: state.data.selectedModels,
  selectedNames: state.data.selectedNewModelNames
})

const mapDispatchToProps = dispatch => ({
  savingInProgress: value => dispatch(savingInProgress(value)),
  savingModelsToDB: (selectedModels, selectedNames, savedSleved) =>
    dispatch(savingModelsToDB(selectedModels, selectedNames, savedSleved)),
  reviewCompleted: () => dispatch(reviewCompleted())
})

export default connect(mapStateToProps, mapDispatchToProps)(ModelHoldings)